/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Push_Rationale_TrainerInputs */

const en_us2_push_rationale_trainer = /** @type {(inputs: Push_Rationale_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your trainer's answer, when it is ready and you are not in the app.`)
};

const pt_br2_push_rationale_trainer = /** @type {(inputs: Push_Rationale_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A resposta do personal, quando ela fica pronta e você não está no app.`)
};

const es_419_push_rationale_trainer = /** @type {(inputs: Push_Rationale_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La respuesta de tu entrenador, cuando esté lista y no estés en la app.`)
};

const pt_pt2_push_rationale_trainer = /** @type {(inputs: Push_Rationale_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A resposta do treinador, quando estiver pronta e não estiveres na app.`)
};

const fr_fr2_push_rationale_trainer = /** @type {(inputs: Push_Rationale_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La réponse de ton coach, quand elle est prête et que tu n'es pas dans l'app.`)
};

const de_de2_push_rationale_trainer = /** @type {(inputs: Push_Rationale_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Antwort deines Coachs, sobald sie fertig ist und du nicht in der App bist.`)
};

const it_it2_push_rationale_trainer = /** @type {(inputs: Push_Rationale_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La risposta del coach, quando è pronta e non sei nell'app.`)
};

/**
* | output |
* | --- |
* | "Your trainer's answer, when it is ready and you are not in the app." |
*
* @param {Push_Rationale_TrainerInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const push_rationale_trainer = /** @type {((inputs?: Push_Rationale_TrainerInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Rationale_TrainerInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_push_rationale_trainer(inputs)
	if (locale === "es-419") return es_419_push_rationale_trainer(inputs)
	if (locale === "pt-PT") return pt_pt2_push_rationale_trainer(inputs)
	if (locale === "fr-FR") return fr_fr2_push_rationale_trainer(inputs)
	if (locale === "de-DE") return de_de2_push_rationale_trainer(inputs)
	if (locale === "it-IT") return it_it2_push_rationale_trainer(inputs)
	return en_us2_push_rationale_trainer(inputs)
});
export { push_rationale_trainer as "push.rationale_trainer" }